import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { ActivitiesComponent } from '../../shared/components/activities/activities.component';

@Component({
  selector: 'app-consumer-activities',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    ActivitiesComponent
  ],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.scss',
})
export class ConsumerActivitiesComponent {
}
